// constants
import { DATA_SETTINGS } from 'modules/OptionChain/consts';
// typings
import { OptionChainTableHeaderColumn } from './typings';

export const getHeaderColumns = (
  tableSettings: OCTableSettings,
  type: OptionTypes,
) => {
  const {
    columnSettings: {
      columns: { showVolume, showIV, showOIChange, showAsk, showBid },
      greeks: { showDelta, showGamma, showTheta, showVega },
    },
    dataSettings: { changeIn },
  } = tableSettings;

  const showChangeInPercent = changeIn === DATA_SETTINGS.changePer;
  const columnDefinitions: [boolean, OptionChainTableHeaderColumn][] = [
    [showVega, { label: 'Vega' }],
    [showGamma, { label: 'Gamma' }],
    [showTheta, { label: 'Theta' }],
    [showDelta, { label: 'Delta' }],
    [true, { label: 'OI', subLabel: '(lakhs)' }],
    [
      showOIChange,
      {
        label: 'OI Change',
        subLabel: showChangeInPercent ? '(%)' : '(lakhs)',
      },
    ],
    [showVolume, { label: 'Volume', subLabel: '(lakhs)' }],
    [showIV, { label: 'IV' }],
    [showBid, { label: 'Bid price' }],
    [showAsk, { label: 'Ask price' }],
    [
      true,
      {
        label: 'LTP',
        subLabel: showChangeInPercent ? '(change %)' : '(change)',
      },
    ],
  ];

  const visibleColumns = columnDefinitions
    .filter(([isVisible]) => isVisible)
    .map(([, column]) => column);

  return type === 'PE' ? visibleColumns.reverse() : visibleColumns;
};
